import * as React from 'react';
import PropTypes from 'prop-types';

const SvgOXE = ({ title, titleId, width, height, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        fill="none"
        width={width}
        height={height}
        aria-labelledby={titleId}
        {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M248.227 172.991C242.517 188.57 233.858 202.726 222.927 214.792H103.204C92.9509 214.793 83.8997 219.056 80.4525 227.55L72.9031 244.465C57.7376 237.229 44.2239 227.101 33.0729 214.792H73.9964C83.5189 214.792 90.3493 211.674 94.9574 200.968L101.896 185.06C106.254 175.415 111.682 172.991 123.27 172.991H248.227Z" fill="white"/>
        <path d="M248.89 86.9346C253.459 100.03 255.967 114.093 256 128.736H139.884C130.045 128.736 121.889 132.993 118.441 141.485L109.591 161.344C105.821 169.903 97.48 172.991 87.9159 172.991H7.76471C2.74086 159.284 9.76624e-05 144.475 9.76624e-05 129.029C9.96116e-05 128.931 -0.000123049 128.834 9.76624e-05 128.736H111.976C121.5 128.736 128.328 125.619 132.937 114.911L139.884 98.9947C144.242 89.353 149.669 86.9346 161.258 86.9346H248.89Z" fill="white"/>
        <path d="M178.543 11.5352C194.627 18.4483 209.011 28.5526 220.887 41.0614H179.266C169.461 41.0624 160.348 46.8324 156.48 55.1788L148.346 73.6779C144.575 82.2357 136.234 85.3162 126.67 85.3162H7.67863C13.7374 68.68 23.1552 53.6561 35.113 41.0614H150.739C160.261 41.0608 167.092 37.943 171.7 27.2365L178.543 11.5352Z" fill="white"/>
    </svg>
);
SvgOXE.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

SvgOXE.defaultProps = {
    title: 'OXE symbol',
    titleId: 'oxe-symbol-icon-title',
    width: 256,
    height: 256
};
export default SvgOXE;
